import React from 'react';

const Icon = () => {
    return (
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.99149 17.8943V15.1342C6.99148 14.4322 7.56381 13.8617 8.27291 13.857H10.8704C11.5829 13.857 12.1605 14.4288 12.1605 15.1342V17.9028C12.1603 18.4989 12.6408 18.986 13.2427 19H14.9744C16.7006 19 18.1 17.6146 18.1 15.9056V8.05405C18.0908 7.38174 17.7719 6.75041 17.2342 6.33973L11.3119 1.61677C10.2744 0.79441 8.79958 0.79441 7.76208 1.61677L1.86582 6.3483C1.32603 6.75732 1.00665 7.3897 1 8.06262V15.9056C1 17.6146 2.39939 19 4.12562 19H5.85727C6.47412 19 6.97418 18.5049 6.97418 17.8943" stroke="#737FA4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default Icon;


